import history from "../history";
import swal from "sweetalert2";
import moment from 'moment';
import i18n from 'i18next'
import harcirahLogo from "../assets/img/harcirah_icon.png";
import portLogo from "../assets/img/port_icon.png"
import dakikaLogo from "../assets/img/dakika_icon.png"
import puantajLogo from "../assets/img/puantaj_icon.png"
import OAuth from './OAuth2';

export function checkTokenUtil() {
    //Gecici cözum uygulama update olmali
    const { url, redirectUri } = OAuth;
    const expireDate = window.localStorage.getItem('expireDate');

    const now = moment(moment.now());
    const formattedExpireDate = moment(parseInt(expireDate));
    const duration = now.diff(formattedExpireDate, 'seconds');

    if (duration > 0) {
        swal({
            title: i18n.t('warning'),
            text: i18n.t('sessionExpired'),
            type: "error",
            showConfirmButton: false,
            timer: 5000
        }).catch(swal.noop);
        window.localStorage.clear()
        window.location = `${url}/logout?redirect_uri=${redirectUri}`
    }
}

export const getUrlParams = () => window.location.search
    .substring(1).split('&')
    .reduce((acc, notParsedValue) => {
        const [key, value] = notParsedValue.split('=');
        return key ? { ...acc, [key]: value } : { ...acc };
    }, {});


export const mapForObject = (obj, param) => {
    var rows = [];
    var key = 0;
    for (var index in obj) {
        if (typeof param === "function")
            rows.push(param(obj[index], index, key));
        else
            if (param === index)
                if (index !== 'costPhoto')
                return obj[index]
        key++;
    }
    return rows;
}

/**
 * Convert Form Data format to JSON Object
 * @param body
 * @returns {Array}
 */
export const convertFormDataToArray = (data) => {
    let costs = [];
    let obj = {};
    for (let pair of data.entries()) {
        let key = pair[0];
        let value = pair[1];
        if (key.includes(".")) {
            let split = key.split(".");
            let keyArr = split[2];
            obj[keyArr] = value;
            if (keyArr === 'status') {
                costs.push(obj);
                obj = {};
            }
        }
    }
    return costs;
}

/**
 *
 * @param {Event} e
 * @param {timemilisecond} maxCostTime
 * @param {int} firstCostMonth
 * @param {int} costMonth
 */
export function onChangeDate(e, maxCostTime, firstCostMonth, costMonth, isfutureDateCostAllowed = true) {
    var getValue = new Date(e.target.value);
    let date = new Date();
    var costDate = (getValue.getTime() / 1000);
    var getNow = (date.getTime() / 1000);
    var calculate = getNow - costDate;
    var day = maxCostTime;
    maxCostTime = (maxCostTime * 86400) + 86400;
    var firstCostMonth = new Date(firstCostMonth);
    var costMonth = new Date(costMonth);

      const checkFutureDatePermission =  !isfutureDateCostAllowed && getValue > date ? false : true;
      if(checkFutureDatePermission){
      if (firstCostMonth === 0 || firstCostMonth.getMonth() === costMonth.getMonth()) {
        if (calculate > maxCostTime) {
          e.target.value = "";
          swal({
            type: "error",
            text: i18n.t('COST_DATE_OLD', {day})
          })
        } else if (Math.abs(calculate) > (maxCostTime - 86400)) {
          e.target.value = "";
          swal({
            type: "error",
            text: i18n.t('COST_DATE_OVER', {day})
          })
        }
      } else {
        e.target.value = "";
        swal({
          type: "error",
          text: i18n.t('COST_DATE_CONTROL_WARNING')
        })
      }
    }
    else {
      e.target.value = "";
        swal({
          type: "error",
          text: i18n.t('COST_FUTURE_DATED_ERROR_MESSAGE')
        })
    }
  }

  export const modulesLogo = {
    port: portLogo,
    harcirah: harcirahLogo,
    puantaj: puantajLogo,
    dakika: dakikaLogo
  };

